import {
  ADD_ROUTES,
  EDIT_TIMELINE,
  ROUTES_AVAILABLE,
  SET_DISABLED_DATES,
  SET_TIMELINE_HIGHLIGHTS,
  SET_TIMELINE_RANGE,
  UPDATE_ROUTE_CACHE,
  UPDATE_ROUTES,
  SET_FOCUSED_ROUTE,
  SET_ROUTE_COLORS,
  SET_SINGLE_TOUR_VIEW,
  SET_ROUTE_PAGINATION,
  EDIT_ROUTE,
  REMOVE_ROUTE,
  SET_ROUTE_STRINGS,
  UPDATE_ROUTE_COLOR,
  SET_ROUTE_RANGE_DATA,
  SET_CACHE,
  SET_PROCESS_BY_DATE, SET_ROUTES_BY_PROCESS, SET_MULTI_TOUR_VIEW,
  SET_ROUTES_LOADING,
  SET_DELETED_ROUTE,
  SET_REASSIGNED_SHIPMENTS,
  SET_IS_MUST_MODE_ENABLED,
  SET_MUST_MODE_SHIPMENTS,
  SET_IS_UPDATE_PLANNING_RUNNING,
  SET_LOCKED_VEHICLES,
  RESET_REASSIGNED_SHIPMENTS,
  SET_SELECTED_PROCESS_DELIVERIES,
  SET_SELECTED_PROCESS_DROPPED_DELIVERIES,
  SET_SELECTED_TOUR_VEHICLE,
} from '../actions/types';
import { endOfDay, isSameDay, startOfDay } from 'date-fns';
import { RoutesReducerState, TLRange } from '../config/types/Routes';
import { dispatchAction } from '../config/types/Common';
export const setSelectedTourVehicle = (routeId: string) => ({
  type: SET_SELECTED_TOUR_VEHICLE,
  data: routeId,
});

const initialState: RoutesReducerState = {
  routes: {},
  routestrings: {},
  colors: {},
  cache: {},
  route_update: undefined,
  routesAvailable: false,
  update: false,
  reload: false,
  editable: false,
  highlights: [],
  singleViewData: {
    route: undefined,
    routestring: undefined,
    color: undefined
  },
  multiRouteFocus: [],
  pagination: {
    page: 0,
    num_results: 0,
    total_pages: 0,
    results_per_page: 20,
    objects: []
  },
  timelineRange: {
    startDate: startOfDay(new Date()),
    endDate: endOfDay(new Date()),
    key: 'selection',
    isSame: true
  },
  selected: [],
  process: {
    ids: [],
    selected: undefined
  },
  focused_route: {
    route: null,
    color: null,
    deliveries: []
  },
  deleted: undefined,
  loading: false,
  deletedRoutes: {},
  reassignedShipments: {},
  isMustModeEnabled: false,
  mustModeShipments: [],
  isUpdatePlanningRunning: false,
  lockedVehicles: [],
  selectedProcessDeliveries: [],
  selectedProcessDroppedDeliveries: [],
  depotLocation: undefined,
  pendingAssignments: {},
  assignedIds: []
};

export const format = ({ startDate, endDate, ...rest }: TLRange) => {
  const start = startOfDay(new Date(startDate));
  const end = endOfDay(new Date(endDate));
  return {
    ...rest,
    startDate: start,
    endDate: end,
    isSame: isSameDay(start, end)
  };
};

const routesReducer = function (state: RoutesReducerState = initialState, action: dispatchAction) {
  switch (action.type) {
    case ADD_ROUTES:
      return {
        ...state,
        routes: action.data.routes,
        update: action.data.update
      };
    case UPDATE_ROUTE_CACHE:
      return {
        ...state,
        cache: action.data
      };
    case SET_ROUTES_BY_PROCESS:
      return {
        ...state,
        process: {
          ...state.process,
          selected: action.data
        }
      };
    case SET_PROCESS_BY_DATE:
      return {
        ...state,
        process: {
          ...state.process,
          ids: action.data
        }
      };

    case SET_ROUTE_RANGE_DATA:
      return {
        ...state,
        pagination: action.data.pagination ?? state.pagination,

        colors: typeof action.data.colors !== 'undefined' ? action.data.colors : state.colors,
        routesAvailable: typeof action.data.available !== 'undefined' ? action.data.available : state.routesAvailable,
        routestrings: typeof action.data.routestrings !== 'undefined' ? action.data.routestrings : state.routestrings,
        routes: typeof action.data.routes !== 'undefined' ? action.data.routes : state.routes,
        update: typeof action.data.update !== 'undefined' ? action.data.update : state.update,
        cache: action.data.cache ?? state.cache,
        deleted: typeof action.data.deleted !== 'undefined' ? action.data.deleted : state.deleted,

        depotLocation: typeof action.data.depotLocation !== 'undefined'
          ? action.data.depotLocation
          : state.depotLocation,

        pendingAssignments: typeof action.data.pendingAssignments !== 'undefined'
          ? action.data.pendingAssignments
          : (state.pendingAssignments || {}),

        assignedIds: typeof action.data.assignedIds !== 'undefined'
          ? action.data.assignedIds
          : (state.assignedIds || []),
      };

    case SET_ROUTE_PAGINATION:
      return {
        ...state,
        pagination: action.data
      };
    case SET_ROUTE_STRINGS:
      return {
        ...state,
        routestrings: action.data
      };
    case SET_ROUTE_COLORS:
      return ({
        ...state,
        colors: action.data
      });
    case UPDATE_ROUTE_COLOR:
      return ({
        ...state,
        colors: {
          ...state.colors,
          [action.data.id]: action.data
        }
      });
    case SET_SINGLE_TOUR_VIEW:
      return ({
        ...state,
        singleViewData: action.data
      });
    case SET_MULTI_TOUR_VIEW:
      return ({
        ...state,
        multiRouteFocus: action.data
      });

    case SET_FOCUSED_ROUTE:
      return ({
        ...state,
        focused_route: {
          route: action.data.route,
          color: action.data.color,
          deliveries: action.data.deliveries
        }
      });
    case SET_DISABLED_DATES:
      return {
        ...state,
        disabledDates: action.data
      };
    case SET_TIMELINE_RANGE:
      return {
        ...state,
        timelineRange: format(action.data)
      };
    case EDIT_TIMELINE:
      return Object.assign({}, state, {
        editable: action.data
      });
    case ROUTES_AVAILABLE:
      return Object.assign({}, state, {
        routesAvailable: action.data
      });
    case UPDATE_ROUTES:
      return Object.assign({}, state, {
        reload: action.data
      });
    case SET_CACHE:
      return {
        ...state,
        cache: action.data
      };
    case EDIT_ROUTE:
      return {
        ...state,
        route_update: action.data
      };
    case REMOVE_ROUTE: {
      const { [action.data.id]: colorToRemove, ...colors } = state.colors;
      const { [action.data.id]: toRemove, ...routes } = state.routes;
      return {
        ...state,
        routes,
        colors
      };
    }
    case SET_TIMELINE_HIGHLIGHTS:
      return {
        ...state,
        highlights: action.data
      };
    case SET_ROUTES_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case SET_DELETED_ROUTE:
      return {
        ...state,
        deletedRoutes: action.data
      };
    case SET_IS_MUST_MODE_ENABLED:
      return {
        ...state,
        isMustModeEnabled: action.data
      };
    case SET_MUST_MODE_SHIPMENTS:
      return {
        ...state,
        mustModeShipments: action.data
      };
    case SET_IS_UPDATE_PLANNING_RUNNING:
      return {
        ...state,
        isUpdatePlanningRunning: action.data
      };
    case SET_LOCKED_VEHICLES:
      return {
        ...state,
        lockedVehicles: action.data
      };

    case RESET_REASSIGNED_SHIPMENTS:
      return {
        ...state,
        reassignedShipments: {}
      };
    case SET_REASSIGNED_SHIPMENTS:
      const updatedVehicleId = action.data.vehicleId;
      return {
        ...state,
        reassignedShipments: { ...state.reassignedShipments, [updatedVehicleId]: [...(state.reassignedShipments[updatedVehicleId] ?? []), action.data.shipment] }
      };
    case SET_SELECTED_PROCESS_DELIVERIES:
      return ({
        ...state,
        selectedProcessDeliveries: action.data
      });
    case SET_SELECTED_PROCESS_DROPPED_DELIVERIES:
      return ({
        ...state,
        selectedProcessDroppedDeliveries: action.data
      });
    case SET_SELECTED_TOUR_VEHICLE:
      return ({
        ...state,
        selected: [action.data],
      });
    default:
      return state;
  }
};

export default routesReducer;
